var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5 5C8.019 5 6 7.019 6 9.5v21c0 2.481 2.019 4.5 4.5 4.5H20v-3h-9.5A1.5 1.5 0 0 1 9 30.5v-21A1.5 1.5 0 0 1 10.5 8h11A1.5 1.5 0 0 1 23 9.5v2.531a6.44 6.44 0 0 1 3-1.006V9.5C26 7.019 23.981 5 21.5 5h-11zm16 8c-2.468 0-4.5 2.032-4.5 4.5v21c0 2.468 2.032 4.5 4.5 4.5h11c2.468 0 4.5-2.032 4.5-4.5v-21c0-2.468-2.032-4.5-4.5-4.5h-11zm0 3h11c.846 0 1.5.654 1.5 1.5v21c0 .846-.654 1.5-1.5 1.5h-11c-.846 0-1.5-.654-1.5-1.5v-21c0-.846.654-1.5 1.5-1.5zm-12 10a1.5 1.5 0 1 0 0 3h3a1.5 1.5 0 1 0 0-3h-3zm16 8a1.5 1.5 0 1 0 0 3h3a1.5 1.5 0 1 0 0-3h-3z"}));
}

Mobile.defaultProps = {"viewBox":"0 0 48 48","fill":"#000000","xmlnsV":"https://vecta.io/nano"};

module.exports = Mobile;

Mobile.default = Mobile;
